// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const progressClasses = {
  bar: "qui-progress__bar",
  errorText: "qui-progress__error-text",
  hint: "qui-progress__hint",
  label: "qui-progress__label",
  root: "qui-progress__root",
  track: "qui-progress__track",
  valueText: "qui-progress__value-text",
} as const
